import { createFileRoute, Outlet } from '@tanstack/react-router'

import type { TabItem } from '@/components/shell'
import { PhoneShell } from '@/components/shell'

/* Home = grid across every role. The tab bar holds only what he WORKS with;
   Profil is an account, so it hangs off the avatar in the Přehled header — the
   same rule as klient and správce (owner, 2026-07-30). */
const FOTOGRAF_TABS: TabItem[] = [
  { label: 'Přehled', href: '/fotograf/prehled', icon: 'grid' },
  { label: 'Dostupnost', href: '/fotograf/dostupnost', icon: 'calendar' },
  { label: 'Knihovna', href: '/fotograf/knihovna', icon: 'folder' },
  { label: 'Výdělky', href: '/fotograf/vydelky', icon: 'money-bill' },
]

export const Route = createFileRoute('/fotograf')({
  component: FotografLayout,
})

function FotografLayout() {
  return (
    <PhoneShell tabs={FOTOGRAF_TABS}>
      <Outlet />
    </PhoneShell>
  )
}
